<mat-dialog-content class="mat-typography">

    <mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
        <ng-container matColumnDef="fieldName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Field Name</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.fieldName}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="oldValue">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Old Value</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.oldValue}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="newValue">
            <mat-header-cell *matHeaderCellDef mat-sort-header>New Value</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.newValue}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Action</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.action}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="createdOn">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Created On</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.createdOn|date:'dd/MMM/yyyy'}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="createdBy">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Created By</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.userGPN}} </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>




</mat-dialog-content>
<mat-dialog-actions align="end">
    <button type="button" mat-stroked-button [mat-dialog-close]="true">Close</button>
</mat-dialog-actions>



